'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002425 from "./presto.-Login-Page-View$$anon$25.js";
import * as $j_presto$002etypes$0024proto$0024$002dGeneric$002dResponse$0024 from "./presto.types$proto$-Generic-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$24() {
  this.b5K = null;
  this.b5C = null;
  this.b5D = false;
  this.b5L = null;
  this.b5M = false;
  this.b5P = null;
  this.b5I = null;
  this.b5J = false;
  this.b5E = null;
  this.b5F = false;
  this.b5G = null;
  this.b5H = false;
  this.b5N = false;
  this.b5O = false;
  this.b5K = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b5P = "GenericResponse";
}
export { $c_Lpresto_LoginPageView$$anon$24 as $c_Lpresto_LoginPageView$$anon$24 };
$p = $c_Lpresto_LoginPageView$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$24;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$24() {
}
export { $h_Lpresto_LoginPageView$$anon$24 as $h_Lpresto_LoginPageView$$anon$24 };
$h_Lpresto_LoginPageView$$anon$24.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b5K;
});
$p.M = (function() {
  if ((!this.b5D)) {
    this.b5C = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b5D = true;
  }
  return this.b5C;
});
$p.O = (function() {
  if ((!this.b5M)) {
    this.b5L = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b5M = true;
  }
  return this.b5L;
});
$p.E = (function() {
  return this.b5P;
});
$p.t = (function() {
  if ((!this.b5J)) {
    this.b5I = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("error", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b5J = true;
  }
  return this.b5I;
});
$p.N = (function() {
  if ((!this.b5F)) {
    this.b5E = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b5F = true;
  }
  return this.b5E;
});
$p.Q = (function() {
  if ((!this.b5H)) {
    this.b5G = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002425.$c_Lpresto_LoginPageView$$anon$25();
    this.b5H = true;
  }
  return this.b5G;
});
$p.v = (function() {
  if ((!this.b5O)) {
    this.b5N = false;
    this.b5O = true;
  }
  return this.b5N;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee156) => ((p) => \u03b4scrutinee156.cGf(p)))($j_presto$002etypes$0024proto$0024$002dGeneric$002dResponse$0024.$m_Lpresto_types$proto$GenericResponse$())));
});
var $d_Lpresto_LoginPageView$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$24, "presto.LoginPageView$$anon$24", ({
  Mp: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$24 as $d_Lpresto_LoginPageView$$anon$24 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$24.js.map
